module.exports = __webpack_public_path__ + "img/academy-product.08f61efe.png";